import * as piggybankCore from '@piggybank/core';

export const getIcon = iconName => {
  const icon = piggybankCore[iconName];

  if (icon == null) {
    throw new Error('invalid icon name');
  }

  return icon;
};
